// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lockCellPopover{padding:0!important;border-radius:14px!important;overflow:hidden}.lockCellPopover .popper__arrow{display:none}.lockPanelFade-enter-active{transition:opacity .18s ease,transform .2s ease}.lockPanelFade-leave-active{transition:opacity .14s ease,transform .14s ease}.lockPanelFade-enter,.lockPanelFade-leave-to{opacity:0;transform:translateY(4px)}", ""]);
// Exports
module.exports = exports;
